import { render, staticRenderFns } from "./AddInterviewer.vue?vue&type=template&id=2528a8f6&scoped=true"
import script from "./AddInterviewer.vue?vue&type=script&lang=js"
export * from "./AddInterviewer.vue?vue&type=script&lang=js"
import style0 from "./AddInterviewer.vue?vue&type=style&index=0&id=2528a8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528a8f6",
  null
  
)

export default component.exports